import { render, staticRenderFns } from "./bingli_list.vue?vue&type=template&id=72e8aff8&scoped=true&"
import script from "./bingli_list.vue?vue&type=script&lang=js&"
export * from "./bingli_list.vue?vue&type=script&lang=js&"
import style0 from "./bingli_list.vue?vue&type=style&index=0&id=72e8aff8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e8aff8",
  null
  
)

export default component.exports